import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionSkillLevelPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionSkillLevel.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionSkillLevel.button1'),
          value: 'beginner',
        },
        {
          text: t('pages.onboarding.questionSkillLevel.button2'),
          value: 'intermediate',
        },
        {
          text: t('pages.onboarding.questionSkillLevel.button3'),
          value: 'advanced',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
